<template>
	<div>
		<!-- 编辑记录 -->
		<div class="content1">
			<div class="all">
				<!-- <el-button size="small" @click="backtrack">返回</el-button> -->
        <div class="outer-row">
          <div
              style="
							font-size: 16px;
							font-weight: bolder;
							margin: 10px 0;
						"
          >
            用户信息
          </div>
          <div class="outer-rol">
            <div class="title">
              <span>基本信息</span>
            </div>
            <div class="outer-rol-info">
              <table class="desctable" cellspacing="0" cellpadding="0">
                <tr>
                  <th>户主姓名</th><td>{{ ruleForm.residentName }}</td>
                  <th>户主电话</th><td>{{ ruleForm.mobile }}</td>
                  <th>用户分类</th><td>{{ ruleForm.userTypeName }}</td>
                </tr>
                <tr>
                  <th>身份证号</th><td>{{ ruleForm.idnumber }}</td>
                  <th>片区</th><td>{{ ruleForm.addrName }}</td>
                  <th>地址</th>
                  <td>
                    <span v-if="ruleForm.addressCoord&&ruleForm.addressCoord!='@'&&ruleForm.addressCoord!=''" style="color:#1082ff;cursor:pointer;display: flex;padding-top:3px" @click="showMap(ruleForm.addressCoord)"><font>{{ ruleForm.address }} </font><i class="el-icon-location" style="font-size:22px;"></i></span> 
                    <span v-else>{{ ruleForm.address }}</span>
                  </td>
                </tr>
                <tr>
                  <th>地址描述</th><td>{{ ruleForm.addressDescribe?ruleForm.addressDescribe:ruleForm.address }}</td>
                  <th>是否点火</th><td>{{ruleForm.fireState == 1 ? '已点火' : (ruleForm.fireState==2?'未点火':'')}}</td>
                  <th>图片</th>
                  <td >
                    <div v-if="ruleForm.picture">
                      <el-image 
                    v-for="(item,index) in ruleForm.picture.split(',') " 
                    :key="index" 
                    style="width: 60px; height: 60px" 
                    :src="item"
                    :preview-src-list="ruleForm.picture.split(',')"
                    ></el-image>
                  </div>
                  </td>
                </tr>
              </table>

            </div>
          </div>

          <div class="outer-rol">
          <div class="title">
            <span>安检信息</span>
          </div>
          <div class="outer-rol-info">
            <table class="desctable" cellspacing="0" cellpadding="0">
              <tr>
                <th>安检联系人</th><td>{{ ruleForm.contactName }}</td>
                <th>联系电话</th><td>{{ ruleForm.contactMobile }}</td>
                <th>是否为租户</th><td>{{
                  ruleForm.islessee === null
                      ? ""
                      : ruleForm.islessee == 1
                          ? "是"
                          : "否"
                }}</td>
              </tr>
            </table>
          </div>
        </div>
          <div class="outer-rol">
            <div class="title">
              <span>表具信息</span>
            </div>
            <div class="outer-rol-info">
              <table class="desctable" cellspacing="0" cellpadding="0">
                <tr>
                  <th>表号</th><td>{{ ruleForm.sheetSteel }}</td>
                  <th>燃气表类型</th><td>{{ ruleForm.tableTypeName }}</td>
                  <th>表向</th><td>{{ruleForm.tableDirectionName}}</td>
                </tr>
                <tr>
                  <th>燃气表厂家</th><td>{{ ruleForm.tableVenderName }}</td>
                  <th>防盗卡号</th><td>{{ ruleForm.tableTitles }}</td>
                  <th>点火日期</th><td>{{ruleForm.openDate}}</td>
                </tr>
                <tr>
                  <th>所接炉具</th><td>{{ ruleForm.receiveStove }}</td>
                  <th>使用时间</th><td>{{ ruleForm.useTime }}</td>
                  <th></th><td></td>
                  <!-- <th>对接系统</th><td>{{
                    getDictLabel(
                        tableSystemList,
                        ruleForm.tableSystem,
                        "id",
                        "label"
                    )
                  }}</td>
                  <th>识别号</th><td>{{ruleForm.identifyNumber}}</td> -->
                </tr>
                <tr>
                  <th>备注</th><td>{{ ruleForm.remark }}</td>
                  <th></th><td></td>
                  <th></th><td></td>
                </tr>
              </table>
            </div>
          </div>
				</div>
			</div>
		</div>
    <!-- 地图组件 -->
		<el-dialog
      :visible.sync="showModel"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <mapDialog v-if="ruleForm.addressCoord" ref="mapDialog" @closeModal="closeModal" :is-show-func="0"  :newForm="ruleForm.addressCoord.split('@')[0]"></mapDialog>
    </el-dialog>
    <el-dialog
      title="图片预览"
      :visible.sync="dialogVisibleImg"
      width="80%"
      :close-on-click-modal="false"
    >
      <div><el-image  :src="dialogImageUrl"  fit="fit"  /></div>
    </el-dialog>
	</div>
</template>


<script>
  import mapDialog from '../mapDialog'
	import { getDictLabel } from "@/utils/common";
  import {userPageList} from "@/RequestPort/peopleUser/people";
	export default {
		name: "peopleUserEdit",
    components:{mapDialog},
		data() {
			return {
        showModel:false,
        dialogVisibleImg:false,
        dialogImageUrl:'',
				getDictLabel,
				ruleForm: {},
				tableSystemList: [
					{ label: "卡表系统", id: 1 },
					{ label: "营收系统", id: 2 },
				],
			};
		},
		created() {
      userPageList({id:this.$route.query.id}).then(res=>{
        	let ruleForm = res.data.records[0];
          let arr = []
				 if (ruleForm.addrId) arr.push(ruleForm.addrId);
			 	 if (ruleForm.addrsId) arr.push(ruleForm.addrsId);
			 	 this.$set(ruleForm, "addrs", arr);  
			 	 this.ruleForm = ruleForm;
      })
		},
		methods: {
			/**
			 * 返回
			 */
			backtrack() {
				this.$router.back(-1);
			},
      showMap(location){
        this.showModel = true
          this.$nextTick(()=>{
            console.log(location)
            this.$refs.mapDialog.openL(location.split('@')[1].split(' ')[0]+' '+location.split('@')[1].split(' ')[1])
          }) 
      },
      closeModal(){
        this.showModel = false
      }
		},
	};
</script>

<style lang="less" scoped>
.desctable{
  width: 100%;
  line-height: 20px;
  border-collapse: collapse;
  border-spacing: 0;
  th{border: 1px solid #EBEEF5;padding:10px;text-align: right;width:125px;background: #F9F9F9;font-weight: normal;}
  td{border: 1px solid #EBEEF5;padding:10px;width:350px;}
}
.title{
  font-size: 15px;font-weight: bolder;margin-bottom: 10px;margin-top:8px;
}
.title::before {
  content: "| ";
  font-weight: bold;
  color: #1082ff;margin-top: -2px;
}
.outer-row {
  .outer-rol {
    padding-left: 15px;
    padding-bottom: 10px;
    .outer-rol-info {
      .el-col {
        padding-bottom: 10px;
      }
      .info {
        display: flex;
        .label {
          margin-right: 5px;
        }
        .text {
        }
      }
    }
  }
}
	.content1 {
		position: relative;
		margin: 10px;
	}
	.all {
		padding: 10px;
		border-radius: 5px;
		background-color: #ffffff;
		padding-bottom: 30px;
		overflow: auto;
		box-sizing: border-box;
		height: calc(100vh - 91px);

		.btns {
			// position: absolute;
			// width: 99%;
			// left: 0;
			// bottom: 20px;
			text-align: center;
		}
		.peopleUserInfo {
			max-width: 800px;
			margin-top: 10px;
			padding-left: 20px;
			.peopleUserList {
				.title {
					font-size: 18px;
					font-weight: bolder;
					margin-bottom: 10px;
				}
				.info {
					display: flex;
					margin-bottom: 10px;
					.name {
						width: 80px;
						text-align: right;
						margin-right: 5px;
					}
					.text {
						flex: 1;
						overflow: hidden;
					}
				}
			}
		}
	}
</style>